
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Hunt_Hess",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Hunt_Hess.vue